import { createQueryKeys } from '@lukemorales/query-key-factory';

export const aiReviews = createQueryKeys('aiReviews', {
  /**
  Get single AI Review by ID
  */
  retrieve: (id: string) => [id],

  /**
  Get public/shared AI Review
  */
  public: (id: string) => [id],

  /**
  Get current user's reviews
  */
  myReviews: null,

  /**
  Get user's last review
  */
  lastReview: null,

  /**
  Delete AI Review
  */
  delete: (id: string) => [id],

  /**
  Toggle public sharing
  */
  togglePublicSharing: (id: string) => [id],

  /**
  Update shared emails
  */
  updateSharedEmails: (id: string) => [id],

  /**
  Create fast review
  */
  create: null,

  /**
  Get AI Reviews statistics
  */
  stats: null,

  /**
  Submit feedback for review
  */
  submitFeedback: (id: string) => [id],

  /**
  Cancel AI Review
  */
  cancel: (id: string) => [id],

  /**
  Restart failed AI Review
  */
  restart: (id: string) => [id],
});
